module.exports = __webpack_public_path__ + "static/media/200512-artwork-fashion-slashie-rob.c1637869.jpg";